// Общая часть инспекции и daily check: что подставить из наклейки и всё ли заполнено.

/** Поля формы, которые берутся из наклейки. */
export function prefillResults(info) {
    const prevResults = {};
    const t = info.tag;

    // Aerial Lift fields — map tag unitSubType to form unitType values
    const subTypeMap = { scissor: 'scissor_lift', boom: 'articulating_boom', manlift: 'man_lift' };
    if (t?.unitSubType) prevResults.unitType = subTypeMap[t.unitSubType] || t.unitSubType;
    if (t?.equipmentNumber) prevResults.liftId = t.equipmentNumber;
    if (t?.location) prevResults.locationOfUse = t.location;
    if (t?.assignedName) prevResults.operatorPrintName = t.assignedName;

    // Crane fields (D-27 form)
    if (t?.owner) prevResults.craneOwner = t.owner;
    if (t?.serialNumber) prevResults.serialNumber = t.serialNumber;
    if (t?.manufacturer) prevResults.craneManufacturer = t.manufacturer;
    if (t?.model) prevResults.model = t.model;
    if (t?.equipmentNumber) prevResults.equipmentNumber = t.equipmentNumber;

    // Maintenance/Forklift — equipment# from serial if no equipmentNumber
    if (!prevResults.equipmentNumber && t?.serialNumber) prevResults.equipmentNumber = t.serialNumber;
    // Maintenance/Forklift — maintenanceInspector from assigned
    if (t?.assignedName) prevResults.maintenanceInspector = t.assignedName;

    // Last inspection date
    if (info.lastInspectionDate) prevResults.dateOfLastInspection = info.lastInspectionDate;

    return prevResults;
}

/** Текст ошибки, если форма заполнена не вся, иначе null. */
export function checklistError(formType, r) {
    if (formType === 'aerial_lift') {
        const missing = [];
        for (let i = 1; i <= 21; i++) {
            if (!r[`item${i}`]) missing.push(i);
        }
        if (missing.length > 0) {
            return `Items not filled: ${missing.join(', ')}`;
        }
        if (!r.unitType) {
            return 'Select Unit Type';
        }
        if (!r.operatorPrintName) {
            return 'Operator Print Name required';
        }
    }

    if (formType === 'crane_forklift') {
        const missing = [];
        for (let i = 1; i <= 18; i++) {
            if (!r[`item${i}`]) missing.push(i);
        }
        if (missing.length > 0) {
            return `Items not filled: ${missing.join(', ')}`;
        }
        if (r.approved === undefined || r.approved === null) {
            return 'Select APPROVED or REJECTED';
        }
    }

    if (formType === 'maintenance_safety') {
        const msKeys = ['cabProtection','cabWorks','seatBelt','fireExtinguisher','blowOutRadiator','cleanCab','inspectBucket','greaseMovingParts','tireTrackRoller','hornFunctions','coolantOilLevels','inspectBelts','checkLeaks','cleanRollerFrames','windshieldWipers','hydraulicCovers','backupAlarm'];
        const msEmpty = msKeys.filter(k => !r[k]);
        if (msEmpty.length > 0) {
            return `${msEmpty.length} checklist items not filled`;
        }
    }

    return null;
}
